// extracted by mini-css-extract-plugin
export default {"range-point":"CustomInputs_range-point__bMmGq","range-point-left":"CustomInputs_range-point-left__mnQEz","range-point-right":"CustomInputs_range-point-right__Lkz0s"};